import React from 'react';
import { GalleryModel } from '../../models/GalleryModel';
import { MediaType } from '../../models/MediaType';

interface FullGalleryItemProps {
    content: GalleryModel;
    onSelect: Function;
}

interface FullGalleryItemState {
}

export default class FullGalleryItem extends React.Component<FullGalleryItemProps, FullGalleryItemState> {
    constructor(props:FullGalleryItemProps) {
        super(props);

        this.state = {}

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        const { content, onSelect } = this.props;
         
        if (this.props.content.youTubeVideoLink) { 
            this.props.content.media = this.props.content.youTubeVideoLink;
            this.props.content.type = MediaType.YouTube;
        }
        e.preventDefault();
        onSelect(content);
    }

    render() {
        const { thumbnail, type } = this.props.content;
        return (
            <div className={`fullGallery__item`} onClick={this.handleClick}>
                <div className="fullGallery__image">
                    <img src= {thumbnail}/>
                </div>
                {
                    type === MediaType.Video ? 
                        <div className="fullGallery__playBtn"></div>
                    : null
                }
                
            </div>
        )
    }
}